
// src/redux/actions/authActions.js
import axios from "axios";
// // Assuming the API URL is set in your .env file
const BASE_URL = process.env.REACT_APP_API_BASE_URL

export const login = (username, password) => async (dispatch) => {
  try {
    const response =  await axios.post(`${BASE_URL}/v1/api/admin-login`, {
              username,
              password,
            });

    if (response.data.meta.status) {
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: response.data.data,
      });
      return response.data;
    } else {
      dispatch({ type: "LOGIN_FAIL" });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: "LOGIN_FAIL" });
    throw error;
  }
};



export const getMyPermissions = () => async (dispatch, getState) => {
  try {
    const token = getState().auth.token || localStorage.getItem("token");
    if (!token) throw new Error("Unauthorized");

    const res = await axios.get(`${BASE_URL}/v1/api/getMyPermissions`, {
      // headers: { authorization: token },
       headers: {
    Authorization: localStorage.getItem("token"),
  },
    });

    if (res.data.meta.status) {
      const permissions = res.data.data.map(p => p.permission_name);
      localStorage.setItem("permissions", JSON.stringify(permissions));

      dispatch({ type: "SET_PERMISSIONS", payload: permissions });
    }
  } catch (err) {
    console.error("Failed to fetch permissions:", err);
  }
};




export const logout = () => (dispatch) => {
  try {
    // Remove all relevant session data from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('phone');
    localStorage.removeItem('role');
    localStorage.removeItem('userId');
    
    // Dispatch logout action to Redux store
    dispatch({ type: "LOGOUT" });

  } catch (error) {
    console.error('Error during logout:', error);
  }
};


